import {
  Button,
  Constrain,
  ControlLink,
  Input,
  LoadingBalls,
  Overlay,
  Popover,
  Stack,
  Text
} from '@moda/om';
import React, { useState, useEffect } from 'react';
import { hrefFor } from '../../routers';
import { tc } from '../../lib/trackingContext';
import { useGuestRequestReturnForm } from './useGuestRequestReturnForm';

import './GuestRequestReturnForm.scss';

export const GuestRequestReturnForm: React.FC = () => {
  const [orderNumber, setOrderNumber] = useState('');
  const [guestEmail, setGuestEmail] = useState('');

  const { handleSubmit, fieldErrors, loading, error } = useGuestRequestReturnForm(
    orderNumber,
    guestEmail
  );

  useEffect(() => {
    tc.track('Start Guest Request Return Page Viewed');
  }, []);

  return (
    <Constrain>
      <Stack alignItems="center" className="GuestRequestReturnForm" space={0}>
        <form onSubmit={handleSubmit}>
          <Stack
            alignItems="center"
            className="GuestRequestReturnForm__content"
            justifyContent="center"
            space={4}
          >
            <h1 className="GuestRequestReturnForm__title">Start Your Return</h1>

            <Text>
              If you purchased as a guest with us, please enter your order number and email address
              below to view your order details.
            </Text>

            <Stack className="GuestRequestReturnForm__row" space={3}>
              {error && (
                <Text color="code-red">
                  We were unable to find an order with the Order Number and Email provided. Please
                  re-enter your information.
                </Text>
              )}

              <Input
                data-test-id="orderNumber"
                id="orderNumber"
                error={fieldErrors.orderNumber?.message}
                onChange={value => setOrderNumber(value)}
                placeholder="Order Number"
                value={orderNumber}
              />

              <Text className="GuestRequestReturnForm__helper">
                Where can I find my{' '}
                <Popover
                  anchor="bottomRight"
                  className="GuestRequestReturnForm__popover"
                  content={
                    <div className="GuestRequestReturnForm__tooltip">
                      <Text>
                        You can find your order number on your packing slip or in the order
                        confirmation email sent from care@modaoperandi.com.
                      </Text>
                    </div>
                  }
                >
                  <ControlLink type="button"> Order Number </ControlLink>
                </Popover>
                ?
              </Text>
            </Stack>

            <Input
              className="GuestRequestReturnForm__row"
              data-test-id="guestEmail"
              id="guestEmail"
              error={fieldErrors.guestEmail?.message}
              onChange={value => setGuestEmail(value)}
              placeholder="Email"
              value={guestEmail}
              type="email"
            />

            <Button className="GuestRequestReturnForm__row" type="submit">
              Find Order
            </Button>

            <Text>
              Already have an account with us?{' '}
              <ControlLink to={hrefFor.RegisterPage()}>Sign in</ControlLink> to view all your
              orders.
            </Text>
          </Stack>
        </form>

        {loading && (
          <Overlay>
            <LoadingBalls />
          </Overlay>
        )}
      </Stack>
    </Constrain>
  );
};
